import ServiceBase from '@/Services/ServiceBase';

export default class PaymentsService extends ServiceBase {
    payments({
        browserInfo,
        paymentMethodInfo,
        campaignId,
        email,
        returnUrl,
        shouldStorePaymentMethod = false,
        netValue,
    }) {
        return this.request('post', `/payments/campaign/${campaignId}`, {
            browserInfo,
            paymentMethodInfo,
            email,
            returnUrl,
            shouldStorePaymentMethod,
            netValue,
        });
    }

    authorize({
        paymentData,
        paymentDetails,
        shouldStorePaymentMethod,
    }) {
        return this.request('post', '/payments/authorize', {
            paymentData,
            paymentDetails,
            shouldStorePaymentMethod,
        });
    }

    paymentInvoice({
        browserInfo,
        paymentMethodInfo,
        invoiceId,
        email,
        returnUrl,
        shouldStorePaymentMethod = false,
    }) {
        return this.request('post', `/payments/invoice/${invoiceId}`, {
            browserInfo,
            paymentMethodInfo,
            email,
            returnUrl,
            shouldStorePaymentMethod,
        });
    }

    getPaymentStatus(paymentId) {
        return this.request('get', `/payments/${paymentId}`, null);
    }

    getStoredPaymentMethods() {
        return this.request('get', '/payments/storedPaymentMethods', null);
    }

    getPaymentConfiguration() {
        return this.request('get', '/payments/configuration', null);
    }

    getTaxStatus(countryCode, taxId) {
        if (!taxId) {
            return this.request('get', `/payments/taxStatus/${countryCode}`, null);
        }

        return this.request('get', `/payments/taxStatus/${countryCode}/${taxId}`, null);
    }

    searchPayments(businessId, { pageNumber, pageSize = 10, searchTerm, sortDirection, sortBy, currencyShortName, statuses, type }) {
        return this.request('post', `/payments/${businessId}/search`, {
            pageNumber,
            pageSize,
            searchTerm,
            sortDirection,
            sortBy,
            currencyShortName,
            statuses,
            type,
        });
    }
}
